/**
 * Store de notificaciones del socio · Sprint 41 · CT Connect V1.
 *
 * Endpoints (cookies HttpOnly):
 *   GET  /api/socios/me/notificaciones            → { items, total, noLeidas }
 *   GET  /api/socios/me/notificaciones/no-leidas  → { noLeidas }
 *   POST /api/socios/me/notificaciones/{id}/leer  → { ok }
 *   POST /api/socios/me/notificaciones/marcar-todas → { ok, marcadas }
 *
 * NO se cachea en localStorage: los datos siempre se leen del servidor.
 */

import { api } from "@/services/api";

export async function listarNotificaciones({ limite = 100 } = {}) {
  const { data } = await api.get("/socios/me/notificaciones", {
    params: { limite },
  });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    total: data?.total ?? 0,
    noLeidas: data?.noLeidas ?? 0,
  };
}

export async function contarNoLeidas() {
  try {
    const { data } = await api.get("/socios/me/notificaciones/no-leidas");
    return Number(data?.noLeidas || 0);
  } catch {
    return 0;
  }
}

export async function marcarLeida(id) {
  await api.post(`/socios/me/notificaciones/${encodeURIComponent(id)}/leer`);
}

export async function marcarTodasLeidas() {
  const { data } = await api.post("/socios/me/notificaciones/marcar-todas");
  return Number(data?.marcadas || 0);
}

const TIPO_LABEL = {
  GENERAL: "General",
  COMPRA_CONFIRMADA: "Compra confirmada",
  EVENTO: "Evento",
  URGENTE: "Urgente",
};

export function etiquetaTipo(tipo) {
  if (!tipo) return "General";
  return TIPO_LABEL[tipo] || tipo.replace(/_/g, " ").toLowerCase();
}
